/*
    Create By fanglijuan 2017-05-26
    人员同步相关服务
*/
'use strict';
angular.module("accountSynchroToPersonalServiceModule", ["createAccountSynchroToPersonalModule", "deleteAccountSynchroToPersonalModule", "transferAccountSynchroToPersonalModule"])
    .factory("accountSynchroToPersonalService", ["$modal", '$q', function($modal, $q) {
        return {
            //新增人员同步
            addSynchroToPersonal: function(item, whichTabShow) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toPersonal/service/create/create_tpl.html",
                    windowClass: 'userManageMent-createAccountSynchroToPersonal-window',
                    backdrop: false,
                    controller: "createAccountSynchroToPersonalCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        },
                        whichTabShow: function() {
                            return whichTabShow;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve("commit");
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            //调动人员同步
            transferSynchroToPersonal: function(item, whichTabShow) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toPersonal/service/transfer/transfer_tpl.html",
                    windowClass: 'userManageMent-transferAccountSynchroToPersonal-window',
                    backdrop: false,
                    controller: "transferAccountSynchroToPersonalCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        },
                        whichTabShow: function() {
                            return whichTabShow;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve("commit");
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            //删除人员同步
            deleteSynchroToPersonal: function(item, whichTabShow) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/groupUserManageMent/accountSynchro/toPersonal/service/delete/delete_tpl.html",
                    windowClass: 'userManageMent-deleteAccountSynchroToPersonal-window',
                    backdrop: false,
                    controller: "deleteAccountSynchroToPersonalCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        },
                        whichTabShow: function() {
                            return whichTabShow;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve("commit");
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
        };
    }]);
